import { Dispatch } from 'redux';
import { setDealsPage } from '@/finsight/application/actions/deals/actions';

export const reInitProfilePage = (dispatch: Dispatch) => {
  dispatch(setDealsPage(1));
};
